import { useMemo } from "react";
import { useMediaQuery } from "@mui/material";

// Returns the ag-grid column defs with the given fields hidden below `maxWidth` px.
export default function useNarrowColumns(columns, hideFields, maxWidth = 900) {
  const narrow = useMediaQuery(`(max-width: ${maxWidth}px)`, { noSsr: true });
  return useMemo(
    () => (narrow ? columns.map((c) => (hideFields.includes(c.field) ? { ...c, hide: true } : c)) : columns),
    [narrow, columns, hideFields]
  );
}
